// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"b40865c7","162":"0575eedb","186":"c7211d1a","424":"20b0807d","478":"20031444","531":"509a3917","693":"363345b1","711":"d2cbf32a"}[chunkId] + ".chunk.js";
};